// FLOW RATE UNIT
export const GET_FLOW_RATE_UNITS = '/flow_rate_unit/query';
export const GET_FLOW_RATE_UNIT = '/flow_rate_unit/';
export const POST_FLOW_RATE_UNIT = '/flow_rate_unit/';
export const PUT_FLOW_RATE_UNIT = '/flow_rate_unit/';
export const DELETE_FLOW_RATE_UNIT = '/flow_rate_unit/';
export const CHECK_FLOW_RATE_UNIT_EXISTS = '/flow_rate_unit/query';
